var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Help-Button"},on:{"click":_vm.callback}},[_c('font-awesome-icon',{attrs:{"icon":"question"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }